module.exports = "<nz-tabset class=\"slide-tab\" [nzShowPagination]=\"true\" [(nzSelectedIndex)]=\"selectedIndex\" (nzSelectedIndexChange)=\"selectedIndexChanged($event)\">\n    <nz-tab *ngFor=\"let item of rechargeTypeList;let i = index\" (nzSelect)=\"active(item,i)\">\n        <ng-template #nzTabHeading>\n            {{item.tabTitle}}\n        </ng-template>\n        <slide-banner [imgData]='item.imgUrlList'></slide-banner>\n    </nz-tab>\n</nz-tabset>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/topdetail/topdetail.component.html
// module id = 1154
// module chunks = 73